import React, { useEffect, useRef, useState } from "react";
import "../../styles/custom-styles.css";
import Festival from "../../common/Festival";
import Footer from "../../common/Footer";
import CoursesList from "./CoursesList";
import moment from "moment";
import { allCoursesStored, LoadingIndicatorGlobal } from "../../utilities";
import { addToStorage } from "../../utilities/localStorage";
import { cartItems, PopupKeys } from "../../redux/constants/courseConstants";
import { useDispatch } from "react-redux";
import { setCartCount, setCartItems, setReferralCode } from "../../redux/reducers/courseSlice";
import { useHistory,Link } from "react-router-dom";
import useCourses from "../VMVideoPlayer/useCourses";

export const getWhatsappPrefix = () => {
  let isMobile = /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase());

  const whatsappURL_Prefix = isMobile ? "https://api.whatsapp.com/send?phone=+918328664336&text=" : "https://web.whatsapp.com/send?phone=+918328664336&text=";

  return whatsappURL_Prefix;
}

export default function Courses() {
  let [monthEnd] = useState(moment(new Date()).format("MMMM"))
  let [monthEndDate] = useState(moment(new Date()).endOf('month').format("Do"));
  const dispatch = useDispatch();
  const history = useHistory();
  const { courses: enrolledCourses = [], loading } = useCourses();
  const [showPopup3, setShowPopup3] = useState(false);
  const timerRef = useRef(0);
  const [remainingTime, setRemainingTime] = useState(30);


  // Note: Enable the below code for showing the popup
  // useEffect(() => {
  //   const alreadyShown3 = localStorage.getItem("showPopup6");
  //   setShowPopup3(alreadyShown3 === null ? true : false);

  //   if (!alreadyShown3) {
  //     timerRef.current = setInterval(() => {
  //       setRemainingTime((prevTime) => prevTime - 1);
  //     }, 1000);

  //     const timeout = setTimeout(() => {
  //       handleShowPopup3();
  //     }, 3*10000);

  //     return () => {
  //       clearTimeout(timeout);
  //       clearInterval(timerRef.current);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    let url = window.location.href;
    const urlParams = new URL(url).searchParams;
    const referralCode = urlParams.get("referralcode");
    if (referralCode) {
      dispatch(setReferralCode(referralCode));
    }
  }, [])

  const addAllToCart = () => {
    const selectedCourses = allCoursesStored.filter(course => !course.courseCombo.length && course.price > 0);
    addToStorage(cartItems, JSON.stringify(selectedCourses));
    dispatch(setCartCount(selectedCourses.length));
    dispatch(setCartItems(selectedCourses));
    history.push('/cartitems');
  }

  const handleShowPopup3 = () => {
    addToStorage(PopupKeys.showPopup3, "true");
    setShowPopup3(false);
    clearInterval(timerRef.current);
  }

  let offer = () => (
    <div
      className="text-capitalize font-weight-bold text-primary"
      style={{ fontFamily: "Century Gothic", fontWeight: "bold" }}>
      <hr />
      {enrolledCourses.length === 0 && <p>
        <div className="cursor-pointer text-white" onClick={addAllToCart}>
          &nbsp;
          <b className="text-uppercase"> <img src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Hand%20gestures/Backhand%20Index%20Pointing%20Right.png" alt="Backhand Index Pointing Right" width="25" height="25" /> <b className="animcolor">BUY All COURSES FOR <small className="text-warning"><b className="fs-4">65%</b></small> DISCOUNT WITH LIFETIME ACCESS</b>
            &nbsp;
            <i className="fa fa-angle-right animcolor2" /> <i className="fa fa-angle-right animcolor3" /> <b className="fs-4">₹ 9,999/-</b>
            <sub className="text-secondary">(<del>₹ 28,700/-</del>)</sub> <img src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Heart%20on%20Fire.png" alt="Partying Face" width="25" height="25"/>
          </b>
        </div>
        <hr />
      </p>}

      {/* <b className="text-warning">🔥 <b className="text-primary">1+1 Offer</b> on all courses (HTML, JS, CSS, ReactJS, NodeJS, React Native, Angular) on ₹1500+ purchase till <b className="text-primary">29th Jan 2025!</b> 🔥</b> */}
      <div className="p-2 rounded alert alert-primary bg-primary text-white">
        <b className="text-white"> <img src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Partying%20Face.png" alt="Heart on Fire" width="25" height="25" /> Get 25% Discount Offer</b> On Any Course
      </div>
      {/* <b className="text-warning"> Minimum <b className="text-info">30% Discount</b> On <b className="text-info">Any Combo Course</b> Till</b> <b className="text-info">31st July 2024.</b> */}
      {/*<i className="fa fa-check" />*/}
      {/*<b className="text-warning"> 75% Discount</b> For Any Course Till 16th August 2022 11:59 PM.*/}
    </div>
  )
  if (loading) return <LoadingIndicatorGlobal />;
  return (
    <div className="container-fluid text-center custom-bg2">
      <Festival />
      <CoursesList title="Full Courses Discount" offer={offer()} enrolledCourses={enrolledCourses} />
      <Footer />
      {/* popups */}
      {showPopup3 && <div className="showPopup text-white text-center">
        <button className="btn btn-danger pull-right m-2 z-2" onClick={handleShowPopup3}>{remainingTime > 6 ? remainingTime : 'X'}</button>
        <div className="popup-animation cursor-pointer" onClick={() => {
          handleShowPopup3();
          history.push("/nextjs");
        }}>
          <div className="bg-primary text-white shadow-lg mb-4 vh-100 d-flex justify-content-center align-items-center w-100 fixed-top">
            <div className="card-body text-center">
              <h2 className="card-title h3 mb-3">
                🚀 <span className="text-warning">Next.js Full Stack Complete Course</span> is live now
              </h2>
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mb-3">
                <Link
                  to="/nextjs"
                  className="btn btn-warning btn-lg fw-bold"
                >
                  📚 View Course Details
                </Link>
              </div>

              <p className="small opacity-75 mb-0 animcolor font-weight-bold">
                🔥 First 100 students get 40% discount on this course. Hurry up!
              </p>
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
}
